import React, { useState } from "react";
import { Button, Dialog, TextField } from "@mui/material";
import { DialogContent, Divider, Stack, Typography } from "@mui/material";
import { Text } from "./styles";
import DateField from "../../components/components/DateField";
import { Toast } from "../../components/components/Toast";
import CustomInput from "../../components/components/CustomInput";
import { toast } from "react-toastify";
function AddCash({ onClose, onSuccess  ,row = null}) {
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    amount: "",
    description: "",
    date: "",
  });
  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };
  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      if(state.date === "") {
        toast.configure();
        toast.info("Please Enter Your Date ");
        return;
       }
     if(state.amount === "") {
      toast.configure();
      toast.info("Please Enter Your Amount");
      return;
     }
     if(state.description === "") {
      toast.configure();
      toast.info("Please Enter Your Description");
      return;
     }
    
      if (row) {
        // Toast("success", "Bank Updated");
        // onUpdate(state);
        // setLoading(false);
        let { data } = await Repo.banks({
          request: {
            method: "saveBank",
            data: {
              company_code: localStorage.getItem("companyCode"),
              bankName: state.bankName,
              balance: state.balance,
              amount: state.amount,
              description: state.description,
              date: state.date,
              accountNumber:state.accountNumber,

            },
          },
        });
        setLoading(false);
        if (data.response.status.statusCode == 200) {
          Toast("success", "Bank added");
        }
        onSuccess();
      } else {
        let { data } = await Repo.banks({
          request: {
            method: "saveBank",
            data: {
              company_code: localStorage.getItem("companyCode"),
              amount: state.amount,
              description: state.description,
              date: state.date,
            },
          },
        });
        setLoading(false);
        if (data.response.status.statusCode == 200) {
          Toast("success", "Cash added");
        }
        onSuccess();
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };
  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="xs">
      <DialogContent>
        <Stack spacing="24px">
          <Stack width="100%">
            <Text
              sx={{
                color: "#4CAF50",
                fontSize: "15px",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              Add Cash
            </Text>
            <Divider sx={{ mt: "16px", color: "#afafaf" }} />
          </Stack>
          <Stack>
            <Typography>Select Date</Typography>
            <DateField name="date" value={state.date} onChange={handleInput} />
          </Stack>
          <CustomInput
            name="amount"
            label="Enter Amount"
            value={state.amount}
            onChange={handleInput}
            onClear={() => handleClear("amount")}
          />
          <TextField
            label="Description"
            multiline
            minRows={3}
            maxRows={6}
            name="description"
            type="number"
            value={state.description}
            onChange={handleInput}
          />
          <Stack direction="row" width="100%" justifyContent="space-evenly">
            <Button
              variant="contained"
              sx={{
                background: "#F2F2F2 !important",
                color: "#767676",
                textTransform: "none",
              }}
              onClick={toggle}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={handleSubmit}
            >
              Add Cash
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
export default AddCash;